import { useEffect, useRef } from "react";
import QRCode from "qrcode";

/**
 * Renders a QR code on a canvas with "Powered by MenuMojo" branding
 * at the bottom. Exposes the canvas via ref so parent can export PNG/PDF.
 */
export function BrandedQRCanvas({ value, size = 420, canvasRef }) {
  const innerRef = useRef(null);
  const ref = canvasRef || innerRef;

  useEffect(() => {
    if (!value || !ref.current) return;
    const canvas = ref.current;
    const padding = 32;
    const footerHeight = 72;
    const width = size;
    const height = size + footerHeight;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    // background
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, width, height);

    // draw QR into an offscreen canvas at size, then blit
    const qrCanvas = document.createElement("canvas");
    QRCode.toCanvas(qrCanvas, value, {
      width: size - padding * 2,
      margin: 0,
      color: { dark: "#0B192C", light: "#FFFFFF" },
      errorCorrectionLevel: "H",
    }).then(() => {
      ctx.drawImage(qrCanvas, padding, padding);

      // Orange accent bar
      ctx.fillStyle = "#FF6500";
      ctx.fillRect(0, size, width, 4);

      // footer
      ctx.fillStyle = "#0B192C";
      ctx.fillRect(0, size + 4, width, footerHeight - 4);

      // branding text
      ctx.fillStyle = "#FFFFFF";
      ctx.font = "600 13px 'Manrope', system-ui, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("Powered by", width / 2 - 42, size + 4 + (footerHeight - 4) / 2);

      ctx.font = "800 18px 'Outfit', system-ui, sans-serif";
      ctx.fillStyle = "#FF6500";
      ctx.fillText("MenuMojo", width / 2 + 34, size + 4 + (footerHeight - 4) / 2);
    });
  }, [value, size, ref]);

  return <canvas ref={ref} className="rounded-xl shadow-lg border border-border" data-testid="qr-canvas" />;
}
